__turbopack_context__.v({
  "container": "UOt8la_container",
});
